import Tag, { Props as TagProps } from '@classify/react-core-components/Tag';

export interface Props extends Omit<TagProps, 'color' | 'variant'> {}

const TagPromotion = ({ ...otherProps }: Props) => <Tag color="yellow" {...otherProps} />;

export default TagPromotion;
